export const isTurnstileDisabled =
  import.meta.env.DEV ||
  import.meta.env.MODE === 'test' ||
  import.meta.env.VITE_DISABLE_TURNSTILE === 'true';

export async function verifyTurnstileToken(
  token: string | null,
  verify: (token: string) => Promise<{ error: unknown }>,
) {
  if (isTurnstileDisabled) return;
  if (!token) throw new Error('Complete a validação anti-robô.');

  const result = await verify(token);
  if (result.error) throw new Error('Falha na validação anti-robô.');
}
